export default __webpack_public_path__ + "static/media/apple.fea40a87.svg";